export enum FeatureFlag {
  LODGEMENT_EDIT_ENABLED = 'LODGEMENT_EDIT_ENABLED',
  API_KEY_MANAGEMENT_ENABLED = 'API_KEY_MANAGEMENT_ENABLED',
};